import { useTheme } from '@mui/material';

type Props = {
  variant?: 'white' | 'dark';
  width?: number | string;
  height?: number | string;
};

export const PoppIcon: React.FC<Props> = ({
  variant,
  width = 104,
  height = 42
}) => {
  const {
    palette: { white, customGrey }
  } = useTheme();

  const color = variant === 'dark' ? customGrey.dark : white;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1003 377"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="popp-icon"
    >
      <path
        d="M70.075 299.136V210.275H131.086C193.645 210.275 238.517 168.046 238.517 103.597C238.517 43.5519 193.202 0 130.201 0H0V299.136H70.075ZM70.075 62.0257H127.326C150.316 62.0257 168.445 82.7021 168.445 103.597C168.445 128.892 150.096 148.469 127.326 148.469H70.075V62.0257Z"
        fill={color}
      />
      <path
        d="M359.703 306.365C432.429 306.365 482.609 252.255 482.609 185.171C482.609 118.524 432.429 63.9757 359.924 63.9757C287.862 63.9757 238.123 118.742 238.123 185.171C238.123 252.036 288.083 306.365 359.703 306.365ZM360.368 243.897C328.313 243.897 305.548 219.922 305.548 185.171C305.548 150.638 328.313 126.443 360.368 126.443C392.418 126.443 415.189 150.638 415.189 185.171C415.189 219.922 392.418 243.897 360.368 243.897Z"
        fill={color}
      />
      <path
        d="M565.097 377V299.577L563.771 272.083C578.137 292.318 602.897 306.616 632.297 306.616C696.182 306.616 741.498 252.068 741.498 185.202C741.498 118.998 696.843 64.2271 631.192 64.2271C604.663 64.2271 578.582 76.326 561.781 100.082V71.2666H497.012V377H565.097ZM619.477 244.371C590.076 244.371 564.433 220.397 564.433 185.202C564.433 152.208 588.748 126.256 619.032 126.256C649.318 126.256 674.298 148.47 674.298 185.202C674.298 223.694 648.433 244.371 619.477 244.371Z"
        fill={color}
      />
      <path
        d="M823.975 377V299.577L822.65 272.083C837.017 292.318 861.776 306.616 891.176 306.616C955.061 306.616 1000.38 252.068 1000.38 185.202C1000.38 118.998 955.722 64.2271 890.071 64.2271C863.542 64.2271 837.46 76.326 820.661 100.082V71.2666H755.89V377H823.975ZM878.355 244.371C848.956 244.371 823.311 220.397 823.311 185.202C823.311 152.208 847.626 126.256 877.911 126.256C908.196 126.256 933.176 148.47 933.176 185.202C933.176 223.694 907.312 244.371 878.355 244.371Z"
        fill={color}
      />
    </svg>
  );
};
